import React, {useState} from 'react';
import {
  FlexItem, FlexLayout, RadioButton, RadioButtonGroup, Text
} from '@salt-ds/core';
import Constants from '../../components/common/Constants';
import {useNavigate} from 'react-router';
import PageNavigation from '../../components/common/page-navigation/PageNavigation';

function RegisterComputerRegistrationOptionsForm(props) {

  const [registerDevice, setRegisterDevice] = React.useState(); // Start as undefined so nothing is selected
  const navigate=useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit=(event)=>{
    event.preventDefault();
    if (registerDevice === undefined) {
      if (props.showErrorOnPage) props.showErrorOnPage("Please select an authentication option to continue.");
      return;
    }
    if (props.setHasError) props.setHasError(false);
    props.setIsLoading(true);
    setIsSubmitting(true);
    setTimeout(() => {
      navigate(Constants.registerComputerComplete, {
        state: { registerDevice, from: Constants.registerComputerOptions }
      });
    }, 1000); // 500ms delay to show spinner
    navigate(Constants.registerComputerComplete,{state:{registerDevice, from: Constants.registerComputerOptions}});
  }

  // Clear error when a radio button is selected
  const handleRadioChange = (value) => {
    setRegisterDevice(value);
    if (props.setHasError) props.setHasError(false);
  };

  return (
    <form autoComplete="off" onSubmit={handleSubmit} data-testid="register-computer-options-form-submit">
      <fieldset disabled={isSubmitting} style={{border:0, padding:0, margin:0}}>
        <FlexLayout direction={'column'} gap={4}>
          <RadioButtonGroup>
            <FlexItem>
              <Text>
                {Constants.registerMyComputer}
              </Text>
            </FlexItem>
            <FlexItem>
              <RadioButton label={Constants.registerComputerStep2RegisterComputerLabel} aria-label="Register Computer"
                           checked={registerDevice === true} onClick={() => handleRadioChange(true)} />
            </FlexItem>
            <br/>
            <FlexItem>
              <Text>
                {Constants.doNotRegisterMyComputer}
              </Text>
            </FlexItem>
            <FlexItem>
              <RadioButton label={Constants.registerComputerStep2DoNotRegisterComputerLabel} aria-label="Do Not Register my Computer"
                           checked={registerDevice === false} onClick={() => handleRadioChange(false)}/>
            </FlexItem>
          </RadioButtonGroup>
        </FlexLayout>
        <PageNavigation style={{marginTop:"8%"}} />
      </fieldset>
    </form>
  );
}

export default RegisterComputerRegistrationOptionsForm;